import { useState, useEffect } from 'react';
import { PlantaFechas, PlantaFechaFilterProps } from '../components/others/Filters/PlantaFechas';
import { dateToInput } from '../utils/utility';
import { getVolumen, getVariaciones } from '../services/monitoreoService';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export const GraficasMovimiento = () => {
  const [filterData, setDataFilter] = useState<Omit<PlantaFechaFilterProps, 'tina'>>({
    planta: 0,
    ruta: 0,
    cupo: 0,
    fechaIni: dateToInput(),
    fechaFin: dateToInput(),
    intervalo: 'diario', // Intervalo inicial
  });

  const [volumenData, setVolumenData] = useState<any[]>([]);
  const [variacionesData, setVariacionesData] = useState<any[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const limiteDeCupos = () => {
    setErrorMessage('Solo se pueden seleccionar hasta 5 cupos.');
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const [volumen, variaciones] = await Promise.all([
          getVolumen(filterData),
          getVariaciones(filterData)
        ]);
        setVolumenData(volumen || []);
        setVariacionesData(variaciones || []);
      } catch (error) {
        console.error("Error al cargar datos", error);
      }
    };
    fetchData();
  }, [filterData]);

  const handleSubmit = (dataFilter: Omit<PlantaFechaFilterProps, 'tina'>) => {

    if (dataFilter.cupo === 0) {
      setErrorMessage('Debe seleccionar un cupo para continuar.');
      return;
    } else {
      setErrorMessage('');
    }
    setDataFilter(dataFilter);
  };

  const agruparPorCupo = (datos: any[], valorKey: string) => {
    const cuposMap: { [key: string]: any } = {};
    datos.forEach(dato => {
      const cupo = dato.cupo;
      if (!cupo) return;
      if (!cuposMap[cupo]) {
        const color = `rgb(${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)})`;
        cuposMap[cupo] = {
          label: `Cupo ${cupo}`,
          data: [],
          borderColor: color,
          backgroundColor: color.replace('rgb', 'rgba').replace(')', ', 0.3)'),
          tension: 0.3
        };
      }
      cuposMap[cupo].data.push({
        x: dato.fecha,
        y: Number(dato[valorKey]) || 0
      });
    });
    return Object.values(cuposMap);
  };

  return (
    <div>
      <h4 className="text-center pt-4">Gráficas de Movimiento</h4>
      <div className="d-flex justify-content-center pt-4">
        <PlantaFechas
          runSearch={handleSubmit}
          initialValuesFilter={filterData}
          hideTina={true}
          hideIntervalo={false}
          isGraficasMovimiento={true}
          limiteDeCupos={limiteDeCupos}
        />
      </div>

      {errorMessage && (
        <div
          style={{
            color: 'red',
            textAlign: 'center',
          }}
        >
          {errorMessage}
        </div>
      )}

      <div className="d-flex flex-wrap justify-content-between mt-4">

        {/* Volumen de leche entregado */}
        {volumenData.length > 0 && (
          <div className="chart-container">
            <h5 className="text-center mb-3">Volumen de leche entregado</h5>
            <Line
              data={{
                labels: Array.from(new Set(volumenData.map(item => item?.fecha).filter(Boolean))).sort(),
                datasets: agruparPorCupo(volumenData, 'total_volumen')
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { position: 'top' },
                  title: { display: false }
                },
                scales: {
                  x: {
                    title: { display: true, text: 'Fecha' },
                    ticks: {
                      autoSkip: false,
                      maxRotation: 45,
                      minRotation: 45,
                    },
                    time: {
                      unit: 'day',
                      tooltipFormat: 'll',
                      displayFormats: {
                        day: 'DD/MM/YYYY',
                      },
                    }
                  },
                  y: {
                    title: { display: true, text: 'Valor' },
                    suggestedMin: 0,
                  }
                }

              }}
            />
          </div>
        )}

        {/* Variaciones de leche entregada */}
        {variacionesData.length > 0 && (
          <div className="chart-container">
            <h5 className="text-center mb-3">Variaciones de leche entregada</h5>
            <Line
              data={{
               labels: Array.from(new Set(variacionesData.map(item => item?.fecha).filter(Boolean))).sort(),
                datasets: agruparPorCupo(variacionesData, 'variacion_litros')
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { position: 'top' },
                  title: { display: false }
                },
                scales: {
                  x: {
                    title: { display: true, text: 'Fecha' },
                    ticks: {
                      autoSkip: false,
                      maxRotation: 45,
                      minRotation: 45,
                    },
                    time: {
                      unit: 'day',
                      tooltipFormat: 'll',
                      displayFormats: {
                        day: 'DD/MM/YYYY',
                      },
                    }
                  },
                  y: {
                    title: { display: true, text: 'Valor' },
                    suggestedMin: 0,
                  }
                }

              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
